const PERMISSAO_ORGAO = "ORGAO";
const PERMISSAO_GESTOR = "GESTOR";
const PERMISSAO_APLICACAO_FORNECEDORA = "API";
const PERMISSAO_PLANO = "PLANO";
const PERMISSAO_PERFIL_GESTOR= "PERFIL_GESTOR";
const PERMISSAO_TERMO_USO = "TERMO_USO";
const PERMISSAO_SOLICITACAO_RELATORIO = "SOL_RELATORIO";
const PERMISSAO_CADASTRO_WHITELIST = "SOL_WHITELIST";
const PERMISSAO_RELATORIO = "RELATORIO";
const PERMISSAO_MONITORACAO= "MON";
const PERMISSAO_APLICACAO_CONSUMIDORA = "APLICACAO";
const PERMISSAO_FATURAMENTO = "FATURAMENTO";
const PERMISSAO_CADASTRO_SOLICITACAO_ADESAO = "SOL_ADESAO";
const PERMISSAO_AUTO_CADASTRO_USUARIO = "AUTO_CADASTRO_USUARIO";
const PERMISSAO_SOL_CADASTRO_ARQUIVO_GV = "SOL_CADASTRO_ARQUIVO_GV";
const PERMISSAO_SUPORTE_TECNICO = "SUPORTE_TECNICO";
const PERMISSAO_CONJUNTO_ARQUIVO_GV = "CONJUNTO_ARQUIVO_GV";
const SOL_ADESAO_ARQUIVO_GV = "SOL_ADESAO_ARQUIVO_GV";
const PERMISSAO_CADASTRO_SOLICITACAO_COMUNICACAO = "SOL_COMUNICACAO";
const PERMISSAO_RELATORIO_TRANSFERENCIA_GV = "RELATORIO_TRANSFERENCIA_GV";

export {PERMISSAO_ORGAO, PERMISSAO_GESTOR, PERMISSAO_APLICACAO_FORNECEDORA, PERMISSAO_PLANO, 
        PERMISSAO_PERFIL_GESTOR, PERMISSAO_TERMO_USO, PERMISSAO_SOLICITACAO_RELATORIO, PERMISSAO_RELATORIO, 
        PERMISSAO_MONITORACAO, PERMISSAO_APLICACAO_CONSUMIDORA, PERMISSAO_FATURAMENTO, PERMISSAO_CONJUNTO_ARQUIVO_GV,
        PERMISSAO_CADASTRO_WHITELIST, PERMISSAO_CADASTRO_SOLICITACAO_ADESAO, PERMISSAO_AUTO_CADASTRO_USUARIO, 
        PERMISSAO_SOL_CADASTRO_ARQUIVO_GV, SOL_ADESAO_ARQUIVO_GV, PERMISSAO_SUPORTE_TECNICO, PERMISSAO_RELATORIO_TRANSFERENCIA_GV,
        PERMISSAO_CADASTRO_SOLICITACAO_COMUNICACAO
}
